import React from 'react';
import { Box, IconButton } from '@mui/material';

interface OrderControlProps {
  onUp: () => void;
  onDown: () => void;
  disabledUp?: boolean;
  disabledDown?: boolean;
}

const ArrowUpIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M4 15l8-8 8 8H4z" />
  </svg>
);

const ArrowDownIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M4 9l8 8 8-8H4z" />
  </svg>
);

export const OrderControl: React.FC<OrderControlProps> = ({
  onUp,
  onDown,
  disabledUp = false,
  disabledDown = false,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <IconButton
        size="small"
        onClick={onUp}
        disabled={disabledUp}
        aria-label="Переместить вверх"
      >
        <ArrowUpIcon />
      </IconButton>
      <IconButton
        size="small"
        onClick={onDown}
        disabled={disabledDown}
        aria-label="Переместить вниз"
      >
        <ArrowDownIcon />
      </IconButton>
    </Box>
  );
};
